import React from 'react';
import { StepContainer } from '../StepContainer';
import { FormSection } from './form/formSection';
import { FormItem } from './form/formItem';

interface GrosOeuvreStepProps {
  data: any;
  onChange: (data: any) => void;
  onNext: () => void;
  onBack: () => void;
}

export const GrosOeuvreStep: React.FC<GrosOeuvreStepProps> = ({
  data = {
    masonry: {},
    foundation: {},
    stairs: {},
    openings: {},
    otherworks: {}
  },
  onChange,
  onNext,
  onBack
}) => {
  const updateSection = (section: string, key: string, value: any) => {
    onChange({
      ...data,
      [section]: {
        ...data[section],
        [key]: value
      }
    });
  };

  return (
    <StepContainer
      title="Gros œuvre"
      description="Détaillez les travaux de gros œuvre nécessaires"
      onNext={onNext}
      onBack={onBack}
    >
      <div className="space-y-6">
        <FormSection
          title="1. Maçonnerie et structure"
          description="Travaux de maçonnerie et renforcement structurel"
        >
          <div className="space-y-4">
            <FormItem
              label="Réparation de murs existants"
              value={data.masonry?.reparationmurs || { selected: false }}
              onChange={(value) => updateSection('masonry', 'reparationmurs', value)}
              withSurface
            />
            <FormItem
              label="Création de nouveaux murs"
              value={data.masonry?.creationmurs || { selected: false }}
              onChange={(value) => updateSection('masonry', 'creationmurs', value)}
              withSurface
            />
            <FormItem
              label="Renforcement des murs porteurs"
              value={data.masonry?.renforcementmurs || { selected: false }}
              onChange={(value) => updateSection('masonry', 'renforcementmurs', value)}
              withSurface
            />
            <FormItem
              label="Renforcement des poutres"
              value={data.masonry?.renforcementpoutres || { selected: false }}
              onChange={(value) => updateSection('masonry', 'renforcementpoutres', value)}
              withSurface
            />
            <FormItem
              label="Renforcement des planchers"
              value={data.masonry?.renforcementplanchers || { selected: false }}
              onChange={(value) => updateSection('masonry', 'renforcementplanchers', value)}
              withSurface
            />
          </div>
        </FormSection>

        <FormSection
          title="2. Fondations"
          description="Travaux sur les fondations"
        >
          <div className="space-y-4">
            <FormItem
              label="Création de dalle béton"
              value={data.foundation?.dallebeton || { selected: false }}
              onChange={(value) => updateSection('foundation', 'dallebeton', value)}
              withSurface
            />
            <FormItem
              label="Renforcement des fondations"
              value={data.foundation?.renforcement || { selected: false }}
              onChange={(value) => updateSection('foundation', 'renforcement', value)}
              withLength
            />
            <FormItem
              label="Mise à niveau des fondations"
              value={data.foundation?.miseaniveau || { selected: false }}
              onChange={(value) => updateSection('foundation', 'miseaniveau', value)}
              withLength
            />
          </div>
        </FormSection>

        <FormSection
          title="3. Escaliers"
          description="Création ou rénovation d'escaliers"
        >
          <div className="space-y-4">
            <FormItem
              label="Escalier en béton (nombre de marches)"
              value={data.stairs?.beton || { selected: false }}
              onChange={(value) => updateSection('stairs', 'beton', value)}
              withQuantity
            />
            <FormItem
              label="Escalier en métal (nombre de marches)"
              value={data.stairs?.metal || { selected: false }}
              onChange={(value) => updateSection('stairs', 'metal', value)}
              withQuantity
            />
            <FormItem
              label="Escalier en bois (nombre de marches)"
              value={data.stairs?.bois || { selected: false }}
              onChange={(value) => updateSection('stairs', 'bois', value)}
              withQuantity
            />
          </div>
        </FormSection>

        <FormSection
          title="4. Ouvertures"
          description="Création et modification d'ouvertures"
        >
          <div className="space-y-4">
            <FormItem
              label="Création d'ouvertures"
              value={data.openings?.creationouvertures || { selected: false }}
              onChange={(value) => updateSection('openings', 'creationouvertures', value)}
              withQuantity
            />
            <FormItem
              label="Agrandissement d'ouvertures"
              value={data.openings?.agrandissementouvertures || { selected: false }}
              onChange={(value) => updateSection('openings', 'agrandissementouvertures', value)}
              withQuantity
            />
          </div>
        </FormSection>

        <FormSection
          title="5. Autres travaux"
          description="Travaux complémentaires de gros œuvre"
        >
          <div className="space-y-4">
            <FormItem
              label="Réparation de fissures importantes"
              value={data.otherworks?.reparationfissures || { selected: false }}
              onChange={(value) => updateSection('otherworks', 'reparationfissures', value)}
            />
            <FormItem
              label="Rénovation de cheminées"
              value={data.otherworks?.renovationcheminees || { selected: false }}
              onChange={(value) => updateSection('otherworks', 'renovationcheminees', value)}
              withQuantity
            />
            <FormItem
              label="Remplacement de gouttières en acier/zinc (y compris descente de toit)"
              value={data.otherworks?.gouttieresacier || { selected: false }}
              onChange={(value) => updateSection('otherworks', 'gouttieresacier', value)}
              withLength
            />
            <FormItem
              label="Remplacement de gouttières en cuivre (y compris descente de toit)"
              value={data.otherworks?.gouttierescuivre || { selected: false }}
              onChange={(value) => updateSection('otherworks', 'gouttierescuivre', value)}
              withLength
            />
          </div>
        </FormSection>
      </div>
    </StepContainer>
  );
};

export default GrosOeuvreStep;
